import React from 'react';
import { useHistory } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import TempusLogo from '../../../../images/tempusLogo.svg';
import typography from '@tcl-boron-styles/typography/dist/index.module.css';
import { Button } from '@tcl-boron-prefabs/button';
import { DEFAULT_AUTH0_REDIRECT_PATH, NavigationPath } from '../../../api/constants';

const Landing: React.FC = () => {
  const history = useHistory();

  const onGoToPortal = () => {
    history.push(DEFAULT_AUTH0_REDIRECT_PATH);
  };

  const onGoToForgotPassword = () => {
    history.push(NavigationPath.FORGOT_PASSWORD);
  };

  return (
    <Grid container direction="column" maxWidth="512px" margin="auto" gap="20px" padding="60px 24px">
      <Grid item alignSelf="center">
        <img src={TempusLogo} alt="Tempus Logo" style={{ maxHeight: '40px', marginTop: '24px' }} />
      </Grid>
      <Grid item alignSelf="center" textAlign={'center'}>
        <p className={typography.sectionHeader}>Welcome to Tempus Patient Portal</p>
        <p className={typography.sectionSubHeader}>
          In order to access your patient portal, look for an email from Tempus with instructions to create your
          password and access your patient portal.
        </p>
      </Grid>
      <Button buttonType="primary" onClick={onGoToPortal} ariaLabel="Go to Portal">
        Go to Portal
      </Button>
      <Grid item alignSelf="center" textAlign={'left'}>
        <p className={typography.sectionHeader} style={{ textAlign: 'center' }}>
          <strong>Use your patient portal to:</strong>
        </p>
        <ul className={typography.body}>
          <li>Monitor your PGx order status, and receive updates to expedite your test process.</li>
          <li>Update your contact and insurance information, and make payments if needed.</li>
          <li>Access your results online; they&apos;ll also be shared with your provider.</li>
        </ul>
      </Grid>
      <Grid item alignSelf="center" textAlign={'center'}>
        <p className={typography.body}>
          Trouble logging in? Click{' '}
          <a className={typography.link} onClick={onGoToForgotPassword}>
            here
          </a>{' '}
          to get access.
        </p>
      </Grid>
    </Grid>
  );
};

export default Landing;
